<template>
  <div class="d-flex flex-row justify-content-between align-items-center px-3 py-1">
    <div>
      <a href="https://sportips.fr" class=" text-white"><img class="logo_sportips_topbar mr-1"
          src="../../assets/sportips_logo.png" />Sportips</a>
    </div>
    <div class="d-flex flex-row justify-content-center align-items-center flex-wrap">
      <div class="font-weight-bold">Administration des résultats</div>

    </div>
    <div>
    </div>
  </div>


</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    sharePage() {
      var _this = this;
      FB.ui(
        {
          method: "share",
          image:
            "https://sportips.fr/plateformeResultats/assets/resultatsenligne.png",
          href:
            "https://sportips.fr/plateformeResultats/#/epreuve?id=" +
            _this.$store.state.event.id,
        },
        function (response) { }
      );
    },
  },
};
</script>

<style scoped>
.fb-button {
  color: #14213D !important;
  background-color: #ececec !important;
  border: none;
}

.fb-button:hover {
  background-color: white !important;
  color: #1877f2 !important;
}

.logo_sportips_topbar {
  height: 25px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/component/Admin/TopBar.vue